<template>
  <div class="badge-container">
    <img :src="src" v-bind:class="{ numbered: numbered }" />
    <span
      class="number"
      v-if="numbered"
      v-bind:class="{
        'for-details': forDetails,
        white: whiteNumber,
        'shift-left': shiftLeft,
      }"
      >{{ this.number }}</span
    >
  </div>
</template>

<script>
export default {
  props: {
    src: String,
    number: Number,
    whiteNumber: Boolean,
    forDetails: Boolean,
    shiftLeft: Boolean,
  },

  computed: {
    numbered() {
      return this.number > 1;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/variables';

img {
  max-width: initial;
  height: 100% !important;

  &.numbered {
    position: relative;
    left: 1px;
  }
}

.badge-container {
  position: relative;
  height: 33px;
}

.number {
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: $blue;
  font-size: 1.75rem;
  position: absolute;
  top: 2px;
  left: 2.5px;
  width: 30px;
  height: 29px;

  &.white {
    color: $white;
  }

  &.for-details {
    font-size: 1.5rem;
    top: -2px;
    left: 0;
  }

  &.shift-left {
    left: -0.5px;
  }
}
</style>
